import { render, staticRenderFns } from "./ChartCard.vue?vue&type=template&id=481913c3&"
import script from "./ChartCard.vue?vue&type=script&lang=js&"
export * from "./ChartCard.vue?vue&type=script&lang=js&"
import style0 from "./ChartCard.vue?vue&type=style&index=0&id=481913c3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports